var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "stock-advantage area"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("产品优势")]), _c("a-row", {
    attrs: {
      gutter: 24
    }
  }, _vm._l(_vm.advantageList, function (item, index) {
    return _c("a-col", {
      key: index,
      attrs: {
        span: 8
      }
    }, [_c("advantage-card", {
      attrs: {
        img: item.img,
        icon: item.icon,
        title: item.title,
        paragraph: item.paragraph
      }
    })], 1);
  }), 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };